/**
 * Plan API Service - Centralized plan-related API calls
 */
import { ApiServices } from './apiServices';
import { ApiConfig } from './ApiConfigs';

/**
 * Get all plans (including inactive) - Super Admin
 */
export const getAllPlans = async () => {
  const res = await ApiServices('get', ApiConfig.PLANS);
  return res?.data ?? [];
};

/**
 * Get active plans only - for plan selection
 */
export const getActivePlans = async () => {
  const res = await ApiServices('get', ApiConfig.PLANS_ACTIVE);
  return res?.data ?? [];
};

/**
 * Get plan by ID
 */
export const getPlanById = async (id) => {
  const res = await ApiServices('get', `${ApiConfig.PLANS}/${id}`);
  return res?.data ?? null;
};

/**
 * Get store's current plan
 */
export const getStorePlan = async (storeId) => {
  if (!storeId) return null;
  const res = await ApiServices('get', `${ApiConfig.PLANS_STORE}/${storeId}`);
  return res?.success ? res.data : null;
};

/**
 * Check if store has active plan
 */
export const checkStorePlan = async (storeId) => {
  if (!storeId) return { hasPlan: false, data: null };
  const res = await ApiServices('get', `${ApiConfig.PLANS_CHECK}?storeId=${storeId}`);
  return res?.success ? { hasPlan: res.hasPlan, data: res.data } : { hasPlan: false, data: null };
};

/**
 * Assign plan to store
 */
export const assignPlanToStore = async (payload) => {
  const res = await ApiServices('post', ApiConfig.PLANS_ASSIGN, payload);
  return res;
};

/**
 * Create plan - Super Admin only
 */
export const createPlan = async (data) => {
  const res = await ApiServices('post', ApiConfig.PLANS, data);
  return res;
};

/**
 * Update plan - Super Admin only
 */
export const updatePlan = async (id, data) => {
  const res = await ApiServices('put', `${ApiConfig.PLANS}/${id}`, data);
  return res;
};

/**
 * Delete plan - Super Admin only
 */
export const deletePlan = async (id) => {
  const res = await ApiServices('delete', `${ApiConfig.PLANS}/${id}`);
  return res;
};

/**
 * Update plan usage (warehouses, drivers, orders)
 */
export const updatePlanUsage = async (storeId, usage) => {
  const res = await ApiServices('put', `${ApiConfig.PLANS_STORE}/${storeId}/usage`, usage);
  return res;
};

export default {
  getAllPlans,
  getActivePlans,
  getPlanById,
  getStorePlan,
  checkStorePlan,
  assignPlanToStore,
  createPlan,
  updatePlan,
  deletePlan,
  updatePlanUsage,
};
